module.exports = __webpack_public_path__ + "img/about-section-certification-process-1280-compressed.9ba1b0a6.png";